import { render } from "./Projects.vue?vue&type=template&id=ce286d0a&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ce286d0a"

export default script